import React from "react";

export const StatCard = ({ icon: Icon, label, value, sub, accent = "navy", testId }) => {
  const iconBg = accent === "gold" ? "bg-gold/15 text-gold" : "bg-navy/10 text-navy";
  const valueColor = accent === "gold" ? "text-gold" : "text-navy";
  return (
    <div
      data-testid={testId}
      className="rounded-xl border border-navy/10 bg-white p-5 shadow-sm transition-all duration-200 hover:shadow-md hover:-translate-y-0.5"
    >
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">{label}</p>
          <p className={`mt-2 font-display text-3xl font-semibold ${valueColor}`}>{value}</p>
          {sub && <p className="mt-1 text-xs text-muted-foreground">{sub}</p>}
        </div>
        {Icon && (
          <div className={`flex h-11 w-11 items-center justify-center rounded-lg ${iconBg}`}>
            <Icon className="h-5 w-5" />
          </div>
        )}
      </div>
    </div>
  );
};
